import { RefObject, useCallback, useEffect, useRef, useState } from "react";
import { ContactDialogType, UserTypes } from "@/types/types";
import ListingContactDialog from "./listing-contact-dialog";
import TourContactDialog from "./tour-contact-dialog";
import LocationContactDialog from "./location-contact-dialog";
import GeneralContactDialog from "./general-contact-dialog";
import { useDialogRouting } from "@/hooks/use-dialog-routing";

export default function ContactDialog({
  type,
  userSub,
  userType,
  photoUrl,
  userName,
  closeCallback,
  phoneNumber,
  hasWhatsAppActive,
  listingId,
  listingTitle,
  dialogRef,
  isComponent = false,
  isPriceRequest = false,
}: {
  type: ContactDialogType;
  userSub: string;
  userType: UserTypes;
  photoUrl: string;
  userName: string;
  closeCallback: () => void;
  phoneNumber: string | null;
  hasWhatsAppActive: boolean | null;
  listingId: string;
  listingTitle?: string;
  dialogRef: RefObject<HTMLDivElement | null>;
  isComponent?: boolean;
  isPriceRequest?: boolean;
}) {
  const [activeType, setActiveType] = useState<ContactDialogType>(type);
  listingTitle = listingTitle || "";

  useDialogRouting("ContactDialog", !isComponent, closeCallback);
  switch (activeType) {
    case ContactDialogType.LISTING:
      return (
        <ListingContactDialog
          userName={userName}
          userSub={userSub}
          userType={userType}
          photoUrl={photoUrl}
          closeCallback={closeCallback}
          phoneNumber={phoneNumber}
          hasWhatsAppActive={hasWhatsAppActive}
          dialogRef={dialogRef}
          listingId={listingId}
          activeType={activeType}
          setActiveType={(type: ContactDialogType) => {
            setActiveType(type);
          }}
          isComponent={isComponent}
          isPriceRequest={isPriceRequest}
        />
      );
    case ContactDialogType.TOUR:
      return (
        <TourContactDialog
          userName={userName}
          userSub={userSub}
          userType={userType}
          photoUrl={photoUrl}
          closeCallback={closeCallback}
          phoneNumber={phoneNumber}
          hasWhatsAppActive={hasWhatsAppActive}
          dialogRef={dialogRef}
          listingId={listingId}
          listingTitle={listingTitle}
          activeType={activeType}
          setActiveType={(type: ContactDialogType) => {
            setActiveType(type);
          }}
          isComponent={isComponent}
        />
      );
    case ContactDialogType.LOCATION_REQUEST:
      return (
        <LocationContactDialog
          userName={userName}
          userSub={userSub}
          userType={userType}
          photoUrl={photoUrl}
          closeCallback={closeCallback}
          listingId={listingId}
          phoneNumber={phoneNumber}
          hasWhatsAppActive={hasWhatsAppActive}
          dialogRef={dialogRef}
          isComponent={isComponent}
        />
      );
    case ContactDialogType.GENERAL:
      return (
        <GeneralContactDialog
          userName={userName}
          userSub={userSub}
          userType={userType}
          photoUrl={photoUrl}
          closeCallback={closeCallback}
          phoneNumber={phoneNumber}
          hasWhatsAppActive={hasWhatsAppActive}
          dialogRef={dialogRef}
          isComponent={isComponent}
        />
      );
    default:
      return null;
  }
}
